import { useQuery } from 'react-query';
import ItemServiceApi from '../../Api/item-service';

export type CountRemainingItemResponse = {
  count: number;
};

export const useGetRemainingItemToUpload = (userId: string) =>
  useQuery<CountRemainingItemResponse>(
    ['item-service-count-remaining-item', userId],
    () => ItemServiceApi.countRemainingItem(userId),
  );
